<h1>{{'referentiels.list.immobilisation.caption' | transloco }}</h1>

<!-- Référentiel Raison Immobilisation -->

@if (userHasReadWritePermission) {
  <p-button [size]="'small'" pRipple [rounded]="true" label="{{ 'button.add' | transloco }}" icon="pi pi-plus" class="btn-light" (onClick)="ajouterRaisonImmobilisation()"></p-button>
}

<p-table
  #raisonImmobilisationTable
  [value]="raisonResult"
  selectionMode="single"
  [(selection)]="selectedRaisonImmobilisation"
  dataKey="id"
  editMode="row"
  [resizableColumns]="true"
  columnResizeMode="expand"
  styleClass="p-datatable-striped"
  [scrollable]="true"
  scrollHeight="400px"
  [virtualScroll]="true"
  [virtualScrollItemSize]="46"
  [totalRecords]="raisonTotalRecords"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="{{'jgrid.defaults.recordtext' | transloco}} {first} - {last} {{'jgrid.defaults.recordtextOf' | transloco}} {totalRecords}"
  [tableStyle]="{ 'min-width': '50rem' }"
>
  <ng-template pTemplate="caption">
    <div class="flex align-items-center justify-content-between">{{ 'referentiels.list.raisonImmobilisationProperties.caption' | transloco }} </div>
  </ng-template>
  <ng-template pTemplate="header">
    <!-- Headers -->
    <tr>
      <th *ngIf="userHasReadWritePermission" style="width: 2%"></th>
      <th pResizableColumn pSortableColumn="raison" style="width: 40%">{{ 'referentiels.list.raisonImmobilisationProperties.raison.header' | transloco }} <p-sortIcon field="raison" /></th>
    </tr>

    <!-- Filters Inputs -->
    <tr>
      <th *ngIf="userHasReadWritePermission"></th>
      <th>
        <p-columnFilter type="text" field="raison" matchMode="contains" placeholder="--Filtre--" ariaLabel="Filtre par raison" [showMenu]="false" [showClearButton]="false" />
      </th>
    </tr>
  </ng-template>

  <!-- Body -->
  <ng-template pTemplate="body" let-rowData let-editing="editing" let-ri="rowIndex">
    <ng-container [formGroup]="raisonImmobilisationForm">
      <tr [pSelectableRow]="rowData" [pEditableRow]="rowData" (click)="onRaisonImmobilisationSelect(rowData)">
        <td *ngIf="userHasReadWritePermission">
          <!-- Column for edit/save buttons -->
          <div class="flex align-items-center justify-content-center">
            <button *ngIf="!editing && userHasReadWritePermission" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" class="p-button-sm" pTooltip="{{ 'button.edit' | transloco }}" (click)="modifierRaisonImmobilisation(rowData, ri)"></button>
            <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" class="p-button-sm" size="small" pTooltip="{{ 'button.validate' | transloco }}" (click)="validerModifsRaisonImmobilisation(rowData)"></button>
            <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" class="p-button-sm" size="small" pTooltip="{{ 'button.cancel' | transloco }}" (click)="annulerModifsRaisonImmobilisation(rowData, ri)"></button>
          </div>
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" formControlName="raison" />
            </ng-template>
            <ng-template pTemplate="output">
              {{ rowData.raison }}
            </ng-template>
          </p-cellEditor>
        </td>
      </tr>
    </ng-container>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="5">{{ 'jgrid.defaults.emptyrecords' | transloco }}.</td>
    </tr>
  </ng-template>

  <ng-template pTemplate="summary">
    <div class="flex align-items-center justify-content-between">{{ 'jgrid.defaults.numberOfResult' | transloco }} : {{ raisonResult ? raisonResult.length : 0 }}</div>
  </ng-template>
</p-table>

<!-- Référentiel Lieu Immobilisation -->

@if (userHasReadWritePermission) {
  <p-button [size]="'small'" pRipple [rounded]="true" label="{{ 'button.add' | transloco }}" icon="pi pi-plus" class="btn-light" (onClick)="ajouterLieuImmobilisation()"></p-button>
}

<p-table
  #lieuImmobilisationTable
  [value]="lieuResult"
  selectionMode="single"
  [(selection)]="selectedLieuImmobilisation"
  dataKey="id"
  editMode="row"
  [resizableColumns]="true"
  columnResizeMode="expand"
  styleClass="p-datatable-striped"
  [scrollable]="true"
  scrollHeight="400px"
  [virtualScroll]="true"
  [virtualScrollItemSize]="46"
  [totalRecords]="lieuTotalRecords"
  [showCurrentPageReport]="true"
  currentPageReportTemplate="{{'jgrid.defaults.recordtext' | transloco}} {first} - {last} {{'jgrid.defaults.recordtextOf' | transloco}} {totalRecords}"
  [tableStyle]="{ 'min-width': '50rem' }"
>
  <ng-template pTemplate="caption">
    <div class="flex align-items-center justify-content-between">{{ 'referentiels.list.lieuImmobilisationProperties.caption' | transloco }}</div>
  </ng-template>
  <ng-template pTemplate="header">
    <!-- Headers -->
    <tr>
      <th *ngIf="userHasReadWritePermission" style="width: 2%"></th>
      <th pResizableColumn pSortableColumn="lieu" style="width: 40%">{{ 'referentiels.list.lieuImmobilisationProperties.raison.header' | transloco }} <p-sortIcon field="lieu" /></th>
    </tr>

    <!-- Filters Inputs -->
    <tr>
      <th *ngIf="userHasReadWritePermission"></th>
      <th>
        <p-columnFilter type="text" field="lieu" matchMode="contains" placeholder="--Filtre--" ariaLabel="Filtre par lieu" [showMenu]="false" [showClearButton]="false" />
      </th>
    </tr>
  </ng-template>

  <!-- Body -->
  <ng-template pTemplate="body" let-rowData let-editing="editing" let-ri="rowIndex">
    <ng-container [formGroup]="lieuImmobilisationForm">
      <tr [pSelectableRow]="rowData" [pEditableRow]="rowData" (click)="onLieuImmobilisationSelect(rowData)">
        <td *ngIf="userHasReadWritePermission">
          <!-- Column for edit/save buttons -->
          <div class="flex align-items-center justify-content-center">
            <button *ngIf="!editing && userHasReadWritePermission" pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil" class="p-button-sm" pTooltip="{{ 'button.edit' | transloco }}" (click)="modifierLieuImmobilisation(rowData, ri)"></button>
            <button *ngIf="editing" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check" class="p-button-sm" size="small" pTooltip="{{ 'button.validate' | transloco }}" (click)="validerModifsLieuImmobilisation(rowData)"></button>
            <button *ngIf="editing" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times" class="p-button-sm" size="small" pTooltip="{{ 'button.cancel' | transloco }}" (click)="annulerModifsLieuImmobilisation(rowData, ri)"></button>
          </div>
        </td>

        <td>
          <p-cellEditor>
            <ng-template pTemplate="input">
              <input pInputText type="text" formControlName="lieu"  />
            </ng-template>
            <ng-template pTemplate="output">
              {{ rowData.lieu }}
            </ng-template>
          </p-cellEditor>
        </td>
      </tr>
    </ng-container>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="5">{{ 'jgrid.defaults.emptyrecords' | transloco }}.</td>
    </tr>
  </ng-template>

  <ng-template pTemplate="summary">
    <div class="flex align-items-center justify-content-between">{{ 'jgrid.defaults.numberOfResult' | transloco }} : {{ lieuResult ? lieuResult.length : 0 }}</div>
  </ng-template>
</p-table>

<p-toast />
